import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/hero-bg.mp4'
import _imports_1 from '../assets/app-store-button.svg'
import _imports_2 from '../assets/GetItOnGooglePlay_Badge_Web_color_French.png'


const _hoisted_1 = { class: "hero-section relative h-screen overflow-hidden" }
const _hoisted_2 = { class: "absolute inset-0 z-0" }
const _hoisted_3 = { class: "relative z-10 h-full flex items-end justify-end pb-28 pr-10" }
const _hoisted_4 = { class: "max-w-lg text-right" }
const _hoisted_5 = { class: "text-4xl sm:text-5xl font-bold mb-4 text-white leading-tight" }

import { ref, onMounted } from 'vue';
import gsap from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  setup(__props) {

gsap.registerPlugin(TextPlugin);

const videoRef = ref<HTMLVideoElement | null>(null);
const typingText = ref<HTMLElement | null>(null);

onMounted(() => {
  const words = ["Jouer.", "Progresser.", "Gagner."];
  let currentIndex = 0;

  const animateText = () => {
    gsap.to(typingText.value, {
      duration: 1.5,
      text: words[currentIndex],
      ease: "power2.out",
      onComplete: () => {
        setTimeout(() => {
          gsap.to(typingText.value, {
            duration: 1,
            text: "",
            ease: "power2.in",
            onComplete: () => {
              currentIndex = (currentIndex + 1) % words.length;
              animateText();
            }
          });
        }, 1500);
      }
    });
  };

  animateText();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", {
        ref_key: "videoRef",
        ref: videoRef,
        class: "absolute inset-0 w-full h-full object-cover",
        autoplay: "",
        loop: "",
        muted: "",
        playsinline: ""
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("source", {
          src: _imports_0,
          type: "video/mp4"
        }, null, -1)
      ]), 512),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-t from-[#1E2652]/90 via-[#1E2652]/50 to-transparent" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, [
          _createElementVNode("span", {
            ref_key: "typingText",
            ref: typingText,
            class: "inline-block"
          }, null, 512)
        ]),
        _cache[2] || (_cache[2] = _createStaticVNode("<p class=\"text-lg text-gray-300 mb-8\" data-v-1c6b4d5c> Élevez votre expérience de jeu avec PadelGo, l&#39;application de réservation de terrains et de mise en relation de joueurs au Maroc. </p><div class=\"flex flex-row flex-nowrap items-center justify-end gap-2 ml-auto\" data-v-1c6b4d5c><a href=\"https://apps.apple.com/ma/app/padelgo/id6743053827?l=fr-FR&amp;itscg=30200&amp;itsct=apps_box_link&amp;mttnsubad=6743053827\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Télécharger dans l’App Store\" class=\"inline-block\" data-v-1c6b4d5c><div class=\"h-[40px] w-[150px] md:h-[56px] md:w-[200px] flex items-center justify-center\" data-v-1c6b4d5c><img src=\"" + _imports_1 + "\" alt=\"Télécharger dans l’App Store\" class=\"h-full w-full object-contain drop-shadow hover:opacity-90 transition-opacity\" data-v-1c6b4d5c></div></a><a href=\"https://play.google.com/store/apps/details?id=com.rmarsile.padelgo\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Disponible sur Google Play\" class=\"inline-block\" data-v-1c6b4d5c><div class=\"h-[40px] w-[150px] md:h-[56px] md:w-[200px] flex items-center justify-center\" data-v-1c6b4d5c><img src=\"" + _imports_2 + "\" alt=\"Disponible sur Google Play\" class=\"h-full w-full object-contain drop-shadow hover:opacity-90 transition-opacity\" data-v-1c6b4d5c></div></a></div>", 2))
      ])
    ])
  ]))
}
}

})